function stopAndRemoveTrack(mediaStream) {
  return function(track) {
    track.stop();
    mediaStream.removeTrack(track);
  };
}

function stopMediaStream(mediaStream) {
  if (!mediaStream) {
    return;
  }

  mediaStream.getTracks().forEach(stopAndRemoveTrack(mediaStream));
}

module.exports = stopMediaStream;



//////////////////
// WEBPACK FOOTER
// ./node_modules/stop-media-stream/index.js
// module id = 1354
// module chunks = 0